<section
  *ngIf="
    aemContent && planFamilyModel && !isNewProductSelectorTemplateEnabled;
    else digitalPlanFirstFlow
  "
>
  <tmo-page-titles
    [pageTitle]="planFamilyModel?.planFamilyDetails[0]?.familyName"
  ></tmo-page-titles>
  <tmo-change-entry
    [aemContent]="aemContent"
    (browseEntryChange)="navigateHome()"
  ></tmo-change-entry>
  <tmo-page-titles
    [pageTitle]="planFamilyModel?.planFamilyDetails[0]?.familyName"
  ></tmo-page-titles>
  <tmo-container-holder
    *ngIf="planFamilyAuthorableData"
    [isDynamicContent]="planFamilyAuthorableData"
  ></tmo-container-holder>
  <div *ngIf="!hasPermissionToAddALine" class="text-center m-t-xl">
    <p *ngIf="isAuthFlow; else unAuthFlow">{{ aemContent?.lineInAccount }}</p>
    <ng-template #unAuthFlow
      ><p>{{ aemContent?.lineInCart }}</p></ng-template
    >
  </div>
  <div class="row">
    <div class="col-12 buttons-container button-spacing-legal">
      <div class="button-box">
        <tmo-button
          [button]="backButton"
          [aria-label]="aemContent?.back"
          (onSelect)="onClickBack()"
          id="tmo-button-back-button-4"
          >{{ aemContent?.back }}</tmo-button
        >
      </div>
      <div class="button-box">
        <tmo-button
          [button]="primaryButton"
          [disabled]="isPrimaryButtonDisabled || !hasPermissionToAddALine"
          (onSelect)="onClickPrimaryCTA()"
          id="tmo-button-primary-button"
          >{{ primaryButton?.name }}</tmo-button
        >
      </div>
    </div>
  </div>
  <div class="row" *ngIf="legalText && legalText?.length > 0">
    <div class="col-12">
      <tmo-container-holder [isDynamicContent]="legalText"></tmo-container-holder>
    </div>
  </div>
</section>
<ng-template #digitalPlanFirstFlow>
  <section *ngIf="aemContent && planFamilyModel" class="outer-div">
    <!-- <tmo-page-titles [pageTitle]="planFamilyModel?.planFamilyDetails[0]?.familyName"></tmo-page-titles> -->
    <ng-container *ngIf="!isFractionalPage">
      <tmo-global-error-message
        [isFractionalPage]="isFractionalPage"
        id="error-message-detail"
      ></tmo-global-error-message>
    </ng-container>
    <tmo-junk-fee-banner [aemContent]="aemContent"></tmo-junk-fee-banner>
    <tmo-change-entry
      [aemContent]="aemContent"
      (browseEntryChange)="navigateHome()"
    ></tmo-change-entry>
    <!-- <tmo-plan-sub-title [aemContent]="aemContent" [selectedFamilyId]="selectedFamilyId"></tmo-plan-sub-title> -->
    <tmo-container-holder
      *ngIf="planFamilyAuthorableData"
      [isDynamicContent]="planFamilyAuthorableData"
    ></tmo-container-holder>
    <ng-container *ngIf="!removeContinue">
      <div
        [ngClass]="
          !(isPrimaryButtonDisabled || !hasPermissionToAddALine || isMaxlinesReached)
            ? 'wide-sticky'
            : 'wide-relative'
        "
      >
        <div class="m-l-lg m-b-xl m-t-xl btn-section">
          <button
            class="btn btn-primary m-lg btn-border-radius"
            [disabled]="isPrimaryButtonDisabled || !hasPermissionToAddALine || isMaxlinesReached"
            (click)="onClickPrimaryCTA()"
            id="tmo-button-primary-button"
          >
            {{ aemContent?.continue }}
          </button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!skipServiceForPlanFirst">
      <hr class="divider" />
      <div class="m-b-lg m-t-lg" *ngIf="!isUpgrade">
        <div class="col-9 col-md-5">
          <h5 class="inline-block">{{ aemContent?.services }}</h5>
        </div>
      </div>
      <hr class="divider m-b-xl" />
    </ng-container>
  </section>
</ng-template>
<tmo-customer-authentication-modal
  *ngIf="showExistingCustomerModal"
  [aemContent]="aemContent"
  [displayModal]="showExistingCustomerModal"
  (closeModal)="closeCustomerModal($event)"
  (newCustomer)="this.isMultiLineEnhancement ? subscribeToPlanConfiguration() : goToNextPage()"
>
</tmo-customer-authentication-modal>
<tmo-spinner
  [setDelay]="
    !this.isMultiLineEnhancement
      ? planFamilyModel && planFamilyAuthorableData && !showSpinner && exixtingLinesLoaded
      : !showSpinner
  "
  [spinnerTextMessage]="showSpinnerMessage ? spinnerMessage : ''"
></tmo-spinner>
<tmo-static-modal
  [modal]="mixedCartModal"
  (onSelect)="handleClickEventMixedCart($event)"
></tmo-static-modal>
<tmo-static-modal
  [modal]="replaceCartModal"
  (onSelect)="handleRevertCart($event)"
  [showIcon]="false"
></tmo-static-modal>
